import React, { useEffect, useState } from "react";
import axios from "axios";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { getToken } from "../services/auth";
import { Alert, Box, CircularProgress, Paper, Typography } from "@mui/material";

const titles = {
  onboarding: "Developer Onboarding Guide",
  genai: "Gen AI Implementation Guide",
  deployment: "Deployment Guide",
  kt: "KT Document",
};
const guideLinks = {
  "DEVELOPER_ONBOARDING_GUIDE.md": "/dev-guide/onboarding",
  "GENAI_ASSISTANT_GUIDE.md": "/dev-guide/genai",
  "DEPLOYMENT_GUIDE.md": "/dev-guide/deployment",
  "KT_DOCUMENT.md": "/dev-guide/kt",
};

export default function DevGuide({ guide }) {
  const [markdown, setMarkdown] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;
    setLoading(true);
    setError("");
    setMarkdown("");
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/dev-guide/${guide}`, {
      responseType: "text", headers: { Authorization: `Bearer ${getToken()}` },
    })
      .then(({ data }) => { if (active) setMarkdown(data); })
      .catch((requestError) => {
        if (active) setError(requestError.response?.data?.error || "Could not load this guide.");
      })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [guide]);

  return <Paper sx={{ maxWidth: 1080, mx: "auto", p: { xs: 2, md: 5 }, my: 2, overflowWrap: "anywhere" }}>
    <Typography variant="h4" sx={{ mb: 3, fontWeight: 700 }}>{titles[guide]}</Typography>
    {loading && <CircularProgress />}
    {error && <Alert severity="warning">{error}</Alert>}
    {!loading && !error && <Box sx={{
      lineHeight: 1.75, color: "text.primary",
      "& h1, & h2, & h3": { mt: 4, mb: 1.5, color: "primary.main" },
      "& p, & ul, & ol": { mb: 2 },
      "& pre": { p: 2, bgcolor: "#eef3f7", overflowX: "auto", borderRadius: 1 },
      "& code": { fontFamily: "monospace", bgcolor: "#eef3f7", px: .5 },
      "& blockquote": { borderLeft: "4px solid #7ba9c6", pl: 2, ml: 0, color: "text.secondary" },
      "& table": { borderCollapse: "collapse", display: "block", overflowX: "auto", mb: 2 },
      "& th, & td": { border: "1px solid #d7e2e9", p: 1, verticalAlign: "top" },
      "& a": { color: "primary.main" },
    }}>
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={{
        a: ({ href, children }) => {
          const fileName = href?.split("#")[0].split("/").pop();
          const destination = guideLinks[fileName] || href;
          return <a href={destination}>{children}</a>;
        },
      }}>{markdown}</ReactMarkdown>
    </Box>}
  </Paper>;
}
